import React from 'react';
import { Table } from 'rsuite-table';
import type BaseFeuilleSaisie from '../../classes/feuilleSaisies/BaseFeuilleSaisie';
import type BaseTypeRegroupement from '../../classes/typeRegroupement/BaseTypeRegroupement';
import ROW_HEIGHT from '../../constants/feuilleSaisie/tableProps';
import TypeBudget from '../../constants/simulation/typeBudget';
import TypePeriode from '../../constants/simulation/typePeriode';
import type TreeRow from '../../interfaces/feuilleSaisie/treeRow';
import type Simulation from '../../interfaces/simulation/simulation';
import renderMontantText from '../../utils/simulation/montant';
import { shouldAddReport } from '../../utils/simulation/simulation';
import 'rsuite-table/dist/css/rsuite-table.min.css';
import './TreeViewFooter.css';

interface TreeViewFooterProps {
	simulation: Simulation;
	data: TreeRow;
	feuilleSaisie: BaseFeuilleSaisie;
	typeRegroupement: BaseTypeRegroupement;
}

const TreeViewFooter = ({
	simulation = null,
	data = null,
	feuilleSaisie = null,
	typeRegroupement = null,
}: TreeViewFooterProps) => (
	<Table
		key="totaux"
		className="treeViewFooter"
		height={ROW_HEIGHT}
		rowHeight={ROW_HEIGHT}
		data={[typeRegroupement.getSolde(data)]}
		showHeader={false}
		rowKey="libelle"
	>
		{({ Cell, Column, HeaderCell }) => (
			<>
				<Column
					flexGrow={simulation?.typePeriode === TypePeriode.CA_CFU ? 4 : 5}
					fullText
					verticalAlign="middle"
				>
					<HeaderCell> </HeaderCell>
					<Cell dataKey="libelle" />
				</Column>
				<Column align="right" flexGrow={1} verticalAlign="middle">
					<HeaderCell> </HeaderCell>
					<Cell dataKey="budget">
						{(rowData) => renderMontantText(rowData.budget)}
					</Cell>
				</Column>

				{simulation?.budget?.type === TypeBudget.COMPTE_ADMINISTRATIF ? (
					<>
						<Column align="right" flexGrow={1} verticalAlign="middle">
							<HeaderCell> </HeaderCell>
							<Cell dataKey="liquide_n">
								{(rowData) => renderMontantText(rowData.liquide_n)}
							</Cell>
						</Column>

						<Column align="right" flexGrow={1} verticalAlign="middle">
							<HeaderCell> </HeaderCell>
							<Cell dataKey="solde">
								{(rowData) => renderMontantText(rowData.solde)}
							</Cell>
						</Column>

						<Column align="right" flexGrow={1} verticalAlign="middle">
							<HeaderCell> </HeaderCell>
							<Cell dataKey="engage_n">
								{(rowData) => renderMontantText(rowData.engage_n)}
							</Cell>
						</Column>
					</>
				) : (
					<Column align="right" flexGrow={1} verticalAlign="middle">
						<HeaderCell> </HeaderCell>
						<Cell dataKey="realise">
							{(rowData) => renderMontantText(rowData.realise)}
						</Cell>
					</Column>
				)}

				{feuilleSaisie.isCreditReporteShown &&
					shouldAddReport(simulation, feuilleSaisie) && (
						<Column align="right" flexGrow={1} verticalAlign="middle">
							<HeaderCell> </HeaderCell>
							<Cell dataKey="report">
								{(rowData) => renderMontantText(rowData.report, true)}
							</Cell>
						</Column>
					)}

				{simulation?.typePeriode === TypePeriode.DEMANDE && (
					<Column align="right" flexGrow={1} verticalAlign="middle">
						<HeaderCell> </HeaderCell>
						<Cell dataKey="montantDemande">
							{(rowData) => renderMontantText(rowData.montantDemande, true)}
						</Cell>
					</Column>
				)}

				{[TypePeriode.PROPOSE, TypePeriode.VOTE]?.includes(
					simulation?.typePeriode,
				) && (
					<Column align="right" flexGrow={1} verticalAlign="middle">
						<HeaderCell> </HeaderCell>
						<Cell dataKey="montantPropose">
							{(rowData) =>
								renderMontantText(
									rowData.montantProp,
									simulation.typePeriode === TypePeriode.PROPOSE,
								)
							}
						</Cell>
					</Column>
				)}

				{simulation?.typePeriode === TypePeriode.VOTE && (
					<Column align="right" flexGrow={1} verticalAlign="middle">
						<HeaderCell> </HeaderCell>
						<Cell dataKey="montantVote">
							{(rowData) => renderMontantText(rowData.montantVote, true)}
						</Cell>
					</Column>
				)}

				{simulation?.typePeriode === TypePeriode.CA_CFU && (
					<Column align="right" flexGrow={1} verticalAlign="middle">
						<HeaderCell> </HeaderCell>
						<Cell dataKey="montantCaCfu">
							{(rowData) => renderMontantText(rowData.rar, true)}
						</Cell>
					</Column>
				)}

				<Column flexGrow={2}>
					<HeaderCell> </HeaderCell>
					<Cell />
				</Column>

				<Column flexGrow={1}>
					<HeaderCell> </HeaderCell>
					<Cell />
				</Column>
			</>
		)}
	</Table>
);

export default TreeViewFooter;
